(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alm-astra-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('astra-gallery')) {
    customElements.define('astra-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.index = 0;
        this.startIndex = 0;
        this.viewport = this.querySelector('.astra-gallery__viewport');
        this.slides = Array.from(this.querySelectorAll('.astra-gallery__slide'));
        this.thumbnails = Array.from(this.querySelectorAll('.astra-gallery__thumbnail'));
        this.dialog = this.querySelector('dialog');
        this.querySelector('.astra-gallery__close').addEventListener('click', () => this.dialog.close());
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.step(Number(button.dataset.step))));
        this.thumbnails.forEach((thumbnail,index) => thumbnail.addEventListener('click', event => { event.preventDefault(); this.select(index); }));
        this.slides.forEach((slide,index) => slide.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || !this.dialog.showModal) return;
          event.preventDefault();
          this.returnFocus = slide;
          this.index = index;
          this.updateZoom();
          this.previousOverflow = document.documentElement.style.overflow;
          this.dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        }));
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.slides[this.index]?.focus({preventScroll:true});
        });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.key === 'Home' || event.key === 'End') this.select(event.key === 'Home' ? 0 : this.slides.length - 1);
          else this.step(event.key === 'ArrowRight' ? 1 : -1);
        });
        let frame;
        this.viewport.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const left = this.viewport.getBoundingClientRect().left;
            let nearest = 0, distance = Infinity;
            this.slides.forEach((slide,index) => {
              const offset = Math.abs(slide.getBoundingClientRect().left - left);
              if (offset < distance) { nearest = index; distance = offset; }
            });
            this.startIndex = Math.min(nearest,this.slides.length - this.visibleCount());
            if (this.index < this.startIndex || this.index >= this.startIndex + this.visibleCount()) this.index = this.startIndex;
            this.updateControls();
          });
        },{passive:true});
        this.variantObserver = new MutationObserver(() => this.syncVariant());
        this.variantObserver.observe(this,{attributes:true,attributeFilter:['data-variant-image']});
        this.syncVariant();
        this.updateControls();
        this.previousVisibleCount = this.visibleCount();
        this.resizeObserver = new ResizeObserver(() => {
          const count = this.visibleCount();
          if (count !== this.previousVisibleCount) { this.previousVisibleCount = count; this.select(this.index); }
        });
        this.resizeObserver.observe(this.viewport);
      }
      disconnectedCallback() {
        this.variantObserver?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow || '';
      }
      syncVariant() {
        const index = this.slides.findIndex(slide => slide.dataset.imageId === this.getAttribute('data-variant-image'));
        if(index >= 0) this.select(index);
      }
      visibleCount() {
        return Math.min(this.slides.length,Math.max(1,Math.round(this.viewport.clientWidth / this.slides[0].getBoundingClientRect().width)));
      }
      step(direction) {
        if (this.dialog.open) { this.select(this.index + direction); return; }
        const positions = this.slides.length - this.visibleCount() + 1;
        this.select((this.startIndex + direction + positions) % positions);
      }
      select(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.startIndex = Math.min(this.index,this.slides.length - this.visibleCount());
        const slide = this.slides[this.startIndex];
        this.viewport.scrollTo({left:this.viewport.scrollLeft + slide.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left - this.viewport.clientLeft,behavior:'instant'});
        this.updateControls();
        if(this.dialog.open) this.updateZoom();
      }
      updateControls() {
        this.thumbnails.forEach((thumbnail,index) => {
          if(index === this.index) thumbnail.setAttribute('aria-current','true');
          else thumbnail.removeAttribute('aria-current');
        });
        this.querySelectorAll('.astra-gallery__count').forEach(count => {
          const inDialog = !!count.closest('dialog');
          const first = inDialog ? this.index : this.startIndex;
          const last = inDialog ? first : Math.min(first + this.visibleCount() - 1,this.slides.length - 1);
          count.textContent = `${first + 1}${last > first ? '–' + (last + 1) : ''} / ${this.slides.length}`;
          if (inDialog) count.setAttribute('aria-label',this.slides[this.index].dataset.counter);
          else count.removeAttribute('aria-label');
        });
        this.querySelectorAll('.astra-gallery__controls button').forEach(button => { button.hidden = this.slides.length <= this.visibleCount(); });
        const thumbnail = this.thumbnails[this.index];
        if (thumbnail) {
          const rail = thumbnail.parentElement;
          const delta = thumbnail.getBoundingClientRect().left - rail.getBoundingClientRect().left;
          if(delta < 0 || delta + thumbnail.offsetWidth > rail.clientWidth) rail.scrollLeft += delta;
        }
      }
      updateZoom() {
        const slide = this.slides[this.index];
        const image = new Image();
        image.alt = slide.querySelector('img').alt;
        image.src = slide.href;
        this.querySelector('.astra-gallery__enlarged').replaceChildren(image);
        this.updateControls();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alm-astra-style"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!document.querySelector('.astra-product')) return;
  const labelStoreReviews = () => {
    const logo = document.getElementById('astra-store-review-logo');
    document.querySelectorAll('.jdgm-carousel-item__product-title').forEach(title => {
      const card = title.closest('.jdgm-carousel-item');
      const text = title.textContent.trim();
      if ((text === 'Librairie Al Minhaj' || text === 'Avis sur le site Librairie Al Minhaj') && !card.querySelector('.jdgm-carousel-item__product-image')) {
        if (text !== 'Avis sur le site Librairie Al Minhaj') title.textContent = 'Avis sur le site Librairie Al Minhaj';
        title.classList.add('astra-store-review-label');
        if (logo && !card.querySelector('.astra-store-review-logo')) {
          const inner = card.querySelector('.jdgm-carousel-item__inner-wrapper');
          let wrapper = card.querySelector('.jdgm-carousel-item__image-wrapper');
          if (!wrapper) { wrapper = document.createElement('div'); wrapper.className = 'jdgm-carousel-item__image-wrapper'; }
          wrapper.appendChild(logo.content.cloneNode(true));
          inner.prepend(wrapper);
        }
      }
    });
  };
  labelStoreReviews();
  const observer = new MutationObserver(labelStoreReviews);
  observer.observe(document.body, {childList:true, subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alm-discovery-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alm-discovery-rail')) {
    customElements.define('alm-discovery-rail', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.rail = this.querySelector('[data-alm-rail-track]');
        if (!this.rail) return;
        this.events?.abort();
        this.dragEvents?.abort();
        this.observer?.disconnect();
        clearTimeout(this.scrollTimer);
        this.scrollTimer = 0;
        this.metrics = null;
        this.layoutDirty = true;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.previous = this.querySelector('[data-alm-rail-previous]');
        this.next = this.querySelector('[data-alm-rail-next]');
        this.controls = this.querySelector('[data-alm-rail-controls]');
        this.range = this.querySelector('[data-alm-rail-range]');
        this.progress = this.querySelector('[data-alm-rail-progress]');
        this.foot = this.querySelector('[data-alm-rail-foot]');
        this.toggle = this.querySelector('[data-alm-rail-toggle]');
        this.items = Array.from(this.rail.children);
        this.rtl = getComputedStyle(this.rail).direction === 'rtl';
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.expanded = this.classList.contains('alm-rail--expanded');
        this.classList.add('alm-rail--ready');
        this.previous?.addEventListener('click', () => this.movePage(-1), { signal });
        this.next?.addEventListener('click', () => this.movePage(1), { signal });
        this.toggle?.addEventListener('click', () => this.toggleAll(), { signal });
        this.progress?.addEventListener('input', () => {
          this.stopMotion();
          this.moveTo(Number(this.progress.value) / 1000 * this.maximum(), false);
        }, { signal });
        this.rail.addEventListener('scroll', () => this.queueScrollUpdate(), { passive: true, signal });
        this.rail.addEventListener('scrollend', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = 0;
          this.queueUpdate();
        }, { passive: true, signal });
        this.rail.addEventListener('pointerdown', event => this.beginDrag(event), { passive: true, signal });
        this.rail.addEventListener('lostpointercapture', event => this.finishDrag(event, false), { signal });
        this.rail.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.rail.addEventListener('click', event => {
          if (event.detail !== 0 && performance.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
        this.rail.addEventListener('wheel', event => this.onWheel(event), { passive: false, signal });
        this.rail.addEventListener('keydown', event => this.onKey(event), { signal });
        this.reducedMotion.addEventListener('change', () => this.stopMotion(), { signal });
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('li');
          if (item && this.rail.contains(item)) this.reveal(item, false);
        }, { signal });
        this.observer = new ResizeObserver(() => {
          this.layoutDirty = true;
          this.queueUpdate();
        });
        this.observer.observe(this.rail);
        this.items.forEach(item => this.observer.observe(item));
        if (this.classList.contains('alm-universes') && !window.Shopify?.designMode) {
          const resetHome = () => {
            if (!this.isConnected || this.expanded) return;
            this.stopMotion();
            this.rail.scrollTo({ left: 0, behavior: 'instant' });
            this.queueUpdate();
          };
          resetHome();
          this.homeResetFrame = requestAnimationFrame(resetHome);
          window.addEventListener('pageshow', () => {
            cancelAnimationFrame(this.homeResetFrame);
            this.homeResetFrame = requestAnimationFrame(resetHome);
          }, { signal });
        } else {
          const current = this.rail.querySelector('[aria-current="page"]');
          if (current && !this.expanded) this.reveal(current, false);
        }
        this.update();
      }
      measure() {
        const width = this.rail.clientWidth;
        const maximum = Math.max(0, this.rail.scrollWidth - width);
        const position = this.rtl ? -this.rail.scrollLeft : this.rail.scrollLeft;
        const bounds = this.rail.getBoundingClientRect();
        const items = this.items.map((item, index) => {
          const rect = item.getBoundingClientRect();
          const start = position + (this.rtl ? bounds.right - rect.right : rect.left - bounds.left);
          return { start, end: start + rect.width, index };
        });
        this.metrics = { width, maximum, items };
        this.layoutDirty = false;
      }
      maximum() {
        if (this.layoutDirty || !this.metrics) this.measure();
        return this.metrics.maximum;
      }
      offset() {
        return Math.max(0, Math.min(this.maximum(), this.rtl ? -this.rail.scrollLeft : this.rail.scrollLeft));
      }
      moveTo(offset, smooth = true) {
        const position = Math.max(0, Math.min(this.maximum(), offset));
        this.rail.scrollTo({ left: this.rtl ? -position : position, behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant' });
      }
      movePage(direction) {
        this.stopMotion();
        this.moveTo(this.offset() + direction * Math.max(140, this.rail.clientWidth * 0.78));
      }
      reveal(item, smooth = true) {
        if (this.expanded) return;
        const bounds = this.rail.getBoundingClientRect();
        const target = item.getBoundingClientRect();
        let delta = 0;
        if (target.left < bounds.left + 2) delta = target.left - bounds.left - 2;
        else if (target.right > bounds.right - 2) delta = target.right - bounds.right + 2;
        if (delta) this.moveTo(this.offset() + delta * (this.rtl ? -1 : 1), smooth);
      }
      beginDrag(event) {
        if (event.isPrimary) this.suppressClickUntil = 0;
        this.stopMotion();
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.expanded || this.maximum() < 3) return;
        this.dragEvents?.abort();
        this.dragEvents = new AbortController();
        const signal = this.dragEvents.signal;
        window.addEventListener('pointermove', move => this.dragMove(move), { signal });
        window.addEventListener('pointerup', up => this.finishDrag(up, true), { signal });
        window.addEventListener('pointercancel', cancel => this.finishDrag(cancel, false), { signal });
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, start: this.rail.scrollLeft, last: this.rail.scrollLeft, time: event.timeStamp, velocity: 0, active: false };
      }
      dragMove(event) {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        const distance = event.clientX - drag.x;
        const vertical = event.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(distance) < 7) {
            if (Math.abs(vertical) > 9) this.finishDrag(event, false);
            return;
          }
          if (Math.abs(vertical) > Math.abs(distance)) {
            this.finishDrag(event, false);
            return;
          }
          drag.active = true;
          this.classList.add('alm-rail--dragging');
          this.rail.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.rail.scrollLeft = drag.start - distance;
        const elapsed = Math.max(1, event.timeStamp - drag.time);
        const velocity = (this.rail.scrollLeft - drag.last) / elapsed;
        drag.velocity = drag.velocity * 0.55 + Math.max(-2.5, Math.min(2.5, velocity)) * 0.45;
        drag.last = this.rail.scrollLeft;
        drag.time = event.timeStamp;
        this.suppressClickUntil = performance.now() + 450;
      }
      finishDrag(event, coast) {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        this.drag = null;
        this.dragEvents?.abort();
        if (this.rail.hasPointerCapture(event.pointerId)) this.rail.releasePointerCapture(event.pointerId);
        this.classList.remove('alm-rail--dragging');
        if (!drag.active) return;
        this.suppressClickUntil = performance.now() + 450;
        if (coast && !this.reducedMotion.matches && event.timeStamp - drag.time < 90 && Math.abs(drag.velocity) > 0.12) this.coast(drag.velocity);
        else this.queueUpdate();
      }
      coast(velocity) {
        this.classList.add('alm-rail--coasting');
        let lastTime = performance.now();
        const step = now => {
          const elapsed = Math.min(32, now - lastTime);
          lastTime = now;
          const previous = this.rail.scrollLeft;
          this.rail.scrollLeft += velocity * elapsed;
          velocity *= Math.pow(0.9, elapsed / 16);
          if (Math.abs(velocity) < 0.025 || Math.abs(previous - this.rail.scrollLeft) < 0.1) {
            this.stopMotion();
            return;
          }
          this.motionFrame = requestAnimationFrame(step);
        };
        this.motionFrame = requestAnimationFrame(step);
      }
      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        this.motionFrame = 0;
        this.classList.remove('alm-rail--coasting');
      }
      onWheel(event) {
        this.stopMotion();
        if (!event.shiftKey || event.ctrlKey || this.expanded) return;
        let delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
        if (event.deltaMode === 1) delta *= 16;
        else if (event.deltaMode === 2) delta *= this.rail.clientWidth;
        if (!delta) return;
        const current = this.offset();
        if (delta < 0 && current < 1 || delta > 0 && current > this.maximum() - 1) return;
        event.preventDefault();
        const now = performance.now();
        this.wheelTarget = this.lastWheel !== undefined && now - this.lastWheel < 140 ? this.wheelTarget + delta : current + delta;
        this.wheelTarget = Math.max(0, Math.min(this.maximum(), this.wheelTarget));
        this.lastWheel = now;
        this.moveTo(this.wheelTarget, false);
      }
      onKey(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const links = Array.from(this.rail.querySelectorAll('a'));
        const index = links.indexOf(document.activeElement);
        if (index < 0 && document.activeElement !== this.rail) return;
        event.preventDefault();
        this.stopMotion();
        let target;
        if (event.key === 'Home') target = links[0];
        else if (event.key === 'End') target = links[links.length - 1];
        else {
          const direction = (event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1);
          target = links[index < 0 ? direction > 0 ? 0 : links.length - 1 : Math.max(0, Math.min(links.length - 1, index + direction))];
        }
        if (target) {
          target.focus({ preventScroll: true });
          if (this.expanded) target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
          else this.reveal(target);
        }
      }
      toggleAll() {
        this.stopMotion();
        if (!this.expanded) this.collapsedOffset = this.offset();
        this.expanded = !this.expanded;
        this.classList.toggle('alm-rail--expanded', this.expanded);
        this.toggle.setAttribute('aria-expanded', String(this.expanded));
        this.toggle.querySelector('span').textContent = this.expanded ? this.toggle.dataset.collapseText : this.toggle.dataset.expandText;
        this.layoutDirty = true;
        if (!this.expanded) this.moveTo(this.collapsedOffset || 0, false);
        this.queueUpdate();
      }
      queueScrollUpdate() {
        if (this.scrollTimer) return;
        this.scrollTimer = setTimeout(() => {
          this.scrollTimer = 0;
          this.queueUpdate();
        }, 80);
      }
      queueUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = 0;
          if (this.isConnected) this.update();
        });
      }
      update() {
        const maximum = this.maximum();
        const current = this.offset();
        const scrollable = !this.expanded && maximum > 3;
        if (this.classList.contains('alm-rail--scrollable') !== scrollable) this.classList.toggle('alm-rail--scrollable', scrollable);
        if (this.controls && this.controls.hidden !== !scrollable) this.controls.hidden = !scrollable;
        if (this.foot && this.foot.hidden !== !scrollable) this.foot.hidden = !scrollable;
        const hideToggle = !scrollable && !this.expanded;
        if (this.toggle && this.toggle.hidden !== hideToggle) this.toggle.hidden = hideToggle;
        const atStart = current < 3;
        const atEnd = current >= maximum - 3;
        if (this.previous && this.previous.disabled !== atStart) this.previous.disabled = atStart;
        if (this.next && this.next.disabled !== atEnd) this.next.disabled = atEnd;
        let label = this.range?.dataset.totalText || '';
        if (scrollable) {
          const visible = this.metrics.items.filter(item => item.end > current + 3 && item.start < current + this.metrics.width - 3);
          if (visible.length && this.range) label = this.range.dataset.rangeText.replace('__first__', String(visible[0].index + 1)).replace('__last__', String(visible[visible.length - 1].index + 1)).replace('__total__', String(this.items.length));
        }
        if (this.range && this.range.textContent !== label) this.range.textContent = label;
        if (this.progress) {
          const value = maximum > 0 ? Math.round(current / maximum * 1000) : 0;
          if (this.progress.value !== String(value)) this.progress.value = String(value);
          if (this.lastProgress !== value) {
            this.progress.style.setProperty('--alm-rail-position', `${value / 10}%`);
            this.lastProgress = value;
          }
          if (this.lastProgressLabel !== label) {
            this.progress.setAttribute('aria-valuetext', label);
            this.lastProgressLabel = label;
          }
        }
      }
      disconnectedCallback() {
        this.dragEvents?.abort();
        clearTimeout(this.scrollTimer);
        this.scrollTimer = 0;
        this.metrics = null;
        this.events?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.homeResetFrame);
        cancelAnimationFrame(this.updateFrame);
        cancelAnimationFrame(this.motionFrame);
        this.updateFrame = 0;
        this.drag = null;
        this.classList.remove('alm-rail--dragging', 'alm-rail--coasting');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alm-discovery-shell"] && !Shopify.designMode) return;
  try {
    (() => {
    const attach = (track) => {
      if (track.dataset.almSwipeBound === 'true') return;
      track.dataset.almSwipeBound = 'true';
      let startX;
      let startY;
      let axis;
      const reset = () => { startX = undefined; startY = undefined; axis = undefined; };
      track.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) { reset(); return; }
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        axis = undefined;
      }, { passive: true, capture: true });
      track.addEventListener('touchmove', event => {
        if (startX === undefined || event.touches.length !== 1) return;
        const dx = event.touches[0].clientX - startX;
        const dy = event.touches[0].clientY - startY;
        if (!axis && Math.max(Math.abs(dx), Math.abs(dy)) > 8) {
          axis = Math.abs(dx) > Math.abs(dy) * 1.15 ? 'horizontal' : 'vertical';
        }
        if (axis === 'horizontal' && event.cancelable) event.preventDefault();
      }, { passive: false, capture: true });
      track.addEventListener('touchend', reset, { passive: true, capture: true });
      track.addEventListener('touchcancel', reset, { passive: true, capture: true });
    };
    const initialize = () => {
      if (!matchMedia('(max-width: 749px)').matches) return;
      document.querySelectorAll('.alm-discovery-theme .alm-revs .jdgm-carousel__item-container').forEach(attach);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

})();
